import * as React from 'react';
import { TableCell } from 'types/common/table';
import { getUtcAndKstTime } from 'modules/billing';
import { IconButton } from '@material-ui/core';
import Create from '@material-ui/icons/Create';
import Delete from '@material-ui/icons/Delete';

import { Comment } from 'types/member';
import { DEFAULT_PAGE_SIZE, NULL_TEXT } from 'constants/common';
import { getTableRowNumber } from 'modules/dataTable';
import { getUserNameFromEmail } from 'modules/utils/user';
import { ServiceType } from 'types/common/service';

import * as S from './Column.styled';

export type UpdateCommentItemType = 'edit' | 'delete' | 'add' | undefined;

interface Props {
  onItemClick: ({ comment, type }: { comment: Comment; type: UpdateCommentItemType }) => void;
  totalItems: number;
  currentPage: number;
}

export const getCommentTableColumn = ({
  currentPage,
  onItemClick,
  totalItems,
}: Props): TableCell<Comment>[] => [
  {
    align: 'center',
    name: 'No.',
    width: '5%',
    key: 'no',
    render: (rowData, columnData, rowIndex) =>
      getTableRowNumber(totalItems, DEFAULT_PAGE_SIZE, currentPage, rowIndex),
  },
  {
    align: 'center',
    name: 'Service Type',
    key: 'serviceType',
    render: ({ serviceType }) => <S.Capitalize>{ServiceType[serviceType ?? 0]}</S.Capitalize>,
  },
  {
    align: 'left',
    name: 'Description',
    key: 'description',
    render: ({ commentText }) => <S.CommentText>{commentText}</S.CommentText>,
  },
  {
    align: 'center',
    width: '18%',
    name: 'Posted Date',
    key: 'postedDate',
    render: ({ histories, writeAt }) => {
      const length = histories.length;
      const hasItem = length > 0;
      const time = hasItem ? histories[length - 1].writeAt : writeAt;

      return getUtcAndKstTime(time);
    },
  },
  {
    align: 'center',
    width: '18%',
    name: 'Updated Date',
    key: 'postedDate',
    render: ({ histories, writeAt }) => {
      return histories.length > 0 ? getUtcAndKstTime(writeAt) : NULL_TEXT;
    },
  },
  {
    align: 'center',
    width: '5%',
    name: 'Operator',
    key: 'operator',
    render: ({ writeBy }) => <S.Capitalize>{getUserNameFromEmail(writeBy)}</S.Capitalize>,
  },
  {
    align: 'center',
    width: '5%',
    name: '',
    key: 'edit',
    render: rowData => (
      <S.EditButtons>
        <IconButton size={'small'} onClick={() => onItemClick({ comment: rowData, type: 'edit' })}>
          <Create fontSize={'small'} color={'action'} />
        </IconButton>
        <IconButton
          size={'small'}
          onClick={() => onItemClick({ comment: rowData, type: 'delete' })}
        >
          <Delete fontSize={'small'} />
        </IconButton>
      </S.EditButtons>
    ),
  },
];
